import { UseMutationOptions } from '@tanstack/react-query';

import { RequestData } from '../hooks/types';
import { useApiDeleteRequest } from '../hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '../hooks/useApiPatchRequest';
import { useApiPostRequest } from '../hooks/useApiPostRequest';
import { useApiUploadRequest } from '../hooks/useApiUploadRequest';
import { buildUseGetQuery } from '../utils';
import {
  DELETE_DRAFT_PLOT_BULK_DELETE_PATH,
  DELETE_DRAFT_PLOT_DISCARD_PATH,
  DELETE_DRAFT_PLOT_GROUP_PATH,
  DELETE_DRAFT_PLOT_PATH,
  DELETE_PLOT_OVERVIEW_MEDIA_FILE_PATH,
  DELETE_PLOT_OVERVIEW_PATH,
  DELETE_PLOT_PATH,
  DeleteDraftPlotBulkDeleteErrorDto,
  DeleteDraftPlotBulkDeleteRequestPathVariables,
  DeleteDraftPlotBulkDeleteRequestQueryParams,
  DeleteDraftPlotBulkDeleteSuccessDto,
  DeleteDraftPlotDiscardErrorDto,
  DeleteDraftPlotDiscardRequestPathVariables,
  DeleteDraftPlotDiscardRequestQueryParams,
  DeleteDraftPlotDiscardSuccessDto,
  DeleteDraftPlotErrorDto,
  DeleteDraftPlotGroupErrorDto,
  DeleteDraftPlotGroupRequestPathVariables,
  DeleteDraftPlotGroupRequestQueryParams,
  DeleteDraftPlotGroupSuccessDto,
  DeleteDraftPlotRequestPathVariables,
  DeleteDraftPlotRequestQueryParams,
  DeleteDraftPlotSuccessDto,
  DeletePlotErrorDto,
  DeletePlotOverviewErrorDto,
  DeletePlotOverviewMediaFileErrorDto,
  DeletePlotOverviewMediaFileRequestPathVariables,
  DeletePlotOverviewMediaFileRequestQueryParams,
  DeletePlotOverviewMediaFileSuccessDto,
  DeletePlotOverviewRequestPathVariables,
  DeletePlotOverviewRequestQueryParams,
  DeletePlotOverviewSuccessDto,
  DeletePlotRequestPathVariables,
  DeletePlotRequestQueryParams,
  DeletePlotSuccessDto,
  GET_BUYER_PLOT_BY_ID_PATH,
  GET_BUYER_PLOTS_PATH,
  GET_DRAFT_PLOT_GROUP_PATH,
  GET_DRAFT_PLOT_PATH,
  GET_DRAFT_PLOT_TASK_STATUS_PATH,
  GET_PLOT_BY_ID_PATH,
  GET_PLOT_PATH,
  GET_PLOT_QUESTIONNAIRE_PATH,
  GetBuyerPlotByIdErrorDto,
  GetBuyerPlotByIdRequestPathVariables,
  GetBuyerPlotByIdRequestQueryParams,
  GetBuyerPlotByIdSuccessDto,
  GetBuyerPlotsErrorDto,
  GetBuyerPlotsRequestPathVariables,
  GetBuyerPlotsRequestQueryParams,
  GetBuyerPlotsSuccessDto,
  GetDraftPlotErrorDto,
  GetDraftPlotGroupErrorDto,
  GetDraftPlotGroupRequestPathVariables,
  GetDraftPlotGroupRequestQueryParams,
  GetDraftPlotGroupSuccessDto,
  GetDraftPlotRequestPathVariables,
  GetDraftPlotRequestQueryParams,
  GetDraftPlotSuccessDto,
  GetDraftPlotTaskStatusErrorDto,
  GetDraftPlotTaskStatusRequestPathVariables,
  GetDraftPlotTaskStatusRequestQueryParams,
  GetDraftPlotTaskStatusSuccessDto,
  GetPlotByIdErrorDto,
  GetPlotByIdRequestPathVariables,
  GetPlotByIdRequestQueryParams,
  GetPlotByIdSuccessDto,
  GetPlotErrorDto,
  GetPlotQuestionnaireErrorDto,
  GetPlotQuestionnaireRequestPathVariables,
  GetPlotQuestionnaireRequestQueryParams,
  GetPlotQuestionnaireSuccessDto,
  GetPlotRequestPathVariables,
  GetPlotRequestQueryParams,
  GetPlotSuccessDto,
  PATCH_DRAFT_PLOT_BULK_ASSIGN_PATH,
  PATCH_DRAFT_PLOT_BULK_PATH,
  PATCH_DRAFT_PLOT_GROUP_PATH,
  PATCH_DRAFT_PLOT_PATH,
  PATCH_PLOT_OVERVIEW_MEDIA_FILE_PATH,
  PATCH_PLOT_OVERVIEW_PATH,
  PATCH_PLOT_PATH,
  PATCH_PLOT_QUESTIONNAIRE_PATH,
  PatchDraftPlotBulkAssignErrorDto,
  PatchDraftPlotBulkAssignRequestBodyData,
  PatchDraftPlotBulkAssignRequestPathVariables,
  PatchDraftPlotBulkAssignRequestQueryParams,
  PatchDraftPlotBulkAssignSuccessDto,
  PatchDraftPlotBulkErrorDto,
  PatchDraftPlotBulkRequestBodyData,
  PatchDraftPlotBulkRequestPathVariables,
  PatchDraftPlotBulkRequestQueryParams,
  PatchDraftPlotBulkSuccessDto,
  PatchDraftPlotErrorDto,
  PatchDraftPlotGroupErrorDto,
  PatchDraftPlotGroupRequestBodyData,
  PatchDraftPlotGroupRequestPathVariables,
  PatchDraftPlotGroupRequestQueryParams,
  PatchDraftPlotGroupSuccessDto,
  PatchDraftPlotRequestBodyData,
  PatchDraftPlotRequestPathVariables,
  PatchDraftPlotRequestQueryParams,
  PatchDraftPlotSuccessDto,
  PatchPlotErrorDto,
  PatchPlotOverviewErrorDto,
  PatchPlotOverviewMediaFileErrorDto,
  PatchPlotOverviewMediaFileRequestBodyData,
  PatchPlotOverviewMediaFileRequestPathVariables,
  PatchPlotOverviewMediaFileRequestQueryParams,
  PatchPlotOverviewMediaFileSuccessDto,
  PatchPlotOverviewRequestBodyData,
  PatchPlotOverviewRequestPathVariables,
  PatchPlotOverviewRequestQueryParams,
  PatchPlotOverviewSuccessDto,
  PatchPlotQuestionnaireErrorDto,
  PatchPlotQuestionnaireRequestBodyData,
  PatchPlotQuestionnaireRequestPathVariables,
  PatchPlotQuestionnaireRequestQueryParams,
  PatchPlotQuestionnaireSuccessDto,
  PatchPlotRequestBodyData,
  PatchPlotRequestPathVariables,
  PatchPlotRequestQueryParams,
  PatchPlotSuccessDto,
  POST_DRAFT_PLOT_ANALYZE_SPREADSHEET_PATH,
  POST_DRAFT_PLOT_COMMIT_ASYNC_PATH,
  POST_DRAFT_PLOT_COMMIT_PATH,
  POST_DRAFT_PLOT_FROM_COORDINATES_PATH,
  POST_DRAFT_PLOT_FROM_SPREADSHEET_PATH,
  POST_DRAFT_PLOT_GROUP_PATH,
  POST_DRAFT_PLOT_PATH,
  POST_DRAFT_PLOT_VALIDATE_NAMES_PATH,
  POST_PLOT_OVERVIEW_MEDIA_FILE_PATH,
  POST_PLOT_OVERVIEW_PATH,
  POST_PLOT_PATH,
  POST_PLOT_VALIDATE_MULTI_POLYGON_PATH,
  PostDraftPlotAnalyzeSpreadsheetErrorDto,
  PostDraftPlotAnalyzeSpreadsheetRequestBodyData,
  PostDraftPlotAnalyzeSpreadsheetRequestPathVariables,
  PostDraftPlotAnalyzeSpreadsheetRequestQueryParams,
  PostDraftPlotAnalyzeSpreadsheetSuccessDto,
  PostDraftPlotCommitAsyncErrorDto,
  PostDraftPlotCommitAsyncRequestBodyData,
  PostDraftPlotCommitAsyncRequestPathVariables,
  PostDraftPlotCommitAsyncRequestQueryParams,
  PostDraftPlotCommitAsyncSuccessDto,
  PostDraftPlotCommitErrorDto,
  PostDraftPlotCommitRequestBodyData,
  PostDraftPlotCommitRequestPathVariables,
  PostDraftPlotCommitRequestQueryParams,
  PostDraftPlotCommitSuccessDto,
  PostDraftPlotErrorDto,
  PostDraftPlotFromCoordinatesErrorDto,
  PostDraftPlotFromCoordinatesRequestBodyData,
  PostDraftPlotFromCoordinatesRequestPathVariables,
  PostDraftPlotFromCoordinatesRequestQueryParams,
  PostDraftPlotFromCoordinatesSuccessDto,
  PostDraftPlotFromSpreadsheetErrorDto,
  PostDraftPlotFromSpreadsheetRequestBodyData,
  PostDraftPlotFromSpreadsheetRequestPathVariables,
  PostDraftPlotFromSpreadsheetRequestQueryParams,
  PostDraftPlotFromSpreadsheetSuccessDto,
  PostDraftPlotGroupErrorDto,
  PostDraftPlotGroupRequestBodyData,
  PostDraftPlotGroupRequestPathVariables,
  PostDraftPlotGroupRequestQueryParams,
  PostDraftPlotGroupSuccessDto,
  PostDraftPlotRequestBodyData,
  PostDraftPlotRequestPathVariables,
  PostDraftPlotRequestQueryParams,
  PostDraftPlotSuccessDto,
  PostDraftPlotValidateNamesErrorDto,
  PostDraftPlotValidateNamesRequestBodyData,
  PostDraftPlotValidateNamesRequestPathVariables,
  PostDraftPlotValidateNamesRequestQueryParams,
  PostDraftPlotValidateNamesSuccessDto,
  PostPlotErrorDto,
  PostPlotOverviewErrorDto,
  PostPlotOverviewMediaFileErrorDto,
  PostPlotOverviewMediaFileRequestBodyData,
  PostPlotOverviewMediaFileRequestPathVariables,
  PostPlotOverviewMediaFileRequestQueryParams,
  PostPlotOverviewMediaFileSuccessDto,
  PostPlotOverviewRequestBodyData,
  PostPlotOverviewRequestPathVariables,
  PostPlotOverviewRequestQueryParams,
  PostPlotOverviewSuccessDto,
  PostPlotRequestBodyData,
  PostPlotRequestPathVariables,
  PostPlotRequestQueryParams,
  PostPlotSuccessDto,
  PostPlotValidateMultiPolygonErrorDto,
  PostPlotValidateMultiPolygonRequestBodyData,
  PostPlotValidateMultiPolygonRequestPathVariables,
  PostPlotValidateMultiPolygonRequestQueryParams,
  PostPlotValidateMultiPolygonSuccessDto,
} from './types/plot';

export const useGetDraftPlot = buildUseGetQuery<
  GetDraftPlotRequestPathVariables,
  GetDraftPlotRequestQueryParams,
  GetDraftPlotSuccessDto,
  GetDraftPlotErrorDto
>((params) => ['land_steward', 'draftplot', params], GET_DRAFT_PLOT_PATH);

export const useGetDraftPlotTaskStatus = buildUseGetQuery<
  GetDraftPlotTaskStatusRequestPathVariables,
  GetDraftPlotTaskStatusRequestQueryParams,
  GetDraftPlotTaskStatusSuccessDto,
  GetDraftPlotTaskStatusErrorDto
>((params) => ['land_steward', 'draftplot', 'task-status', params], GET_DRAFT_PLOT_TASK_STATUS_PATH);

export const usePostDraftPlot = () => {
  return useApiUploadRequest<
    PostDraftPlotRequestPathVariables,
    PostDraftPlotRequestQueryParams,
    PostDraftPlotRequestBodyData,
    PostDraftPlotSuccessDto,
    PostDraftPlotErrorDto
  >(POST_DRAFT_PLOT_PATH);
};

export const usePostDraftPlotCommit = () => {
  return useApiPostRequest<
    PostDraftPlotCommitRequestPathVariables,
    PostDraftPlotCommitRequestQueryParams,
    PostDraftPlotCommitRequestBodyData,
    PostDraftPlotCommitSuccessDto,
    PostDraftPlotCommitErrorDto
  >(POST_DRAFT_PLOT_COMMIT_PATH);
};

export const usePostDraftPlotCommitAsync = () => {
  return useApiPostRequest<
    PostDraftPlotCommitAsyncRequestPathVariables,
    PostDraftPlotCommitAsyncRequestQueryParams,
    PostDraftPlotCommitAsyncRequestBodyData,
    PostDraftPlotCommitAsyncSuccessDto,
    PostDraftPlotCommitAsyncErrorDto
  >(POST_DRAFT_PLOT_COMMIT_ASYNC_PATH);
};

export const usePostDraftPlotValidateNames = () => {
  return useApiPostRequest<
    PostDraftPlotValidateNamesRequestPathVariables,
    PostDraftPlotValidateNamesRequestQueryParams,
    PostDraftPlotValidateNamesRequestBodyData,
    PostDraftPlotValidateNamesSuccessDto,
    PostDraftPlotValidateNamesErrorDto
  >(POST_DRAFT_PLOT_VALIDATE_NAMES_PATH);
};

export const usePostDraftPlotFromCoordinates = () => {
  return useApiPostRequest<
    PostDraftPlotFromCoordinatesRequestPathVariables,
    PostDraftPlotFromCoordinatesRequestQueryParams,
    PostDraftPlotFromCoordinatesRequestBodyData,
    PostDraftPlotFromCoordinatesSuccessDto,
    PostDraftPlotFromCoordinatesErrorDto
  >(POST_DRAFT_PLOT_FROM_COORDINATES_PATH);
};

export const usePostDraftPlotAnalyzeSpreadsheet = () => {
  return useApiUploadRequest<
    PostDraftPlotAnalyzeSpreadsheetRequestPathVariables,
    PostDraftPlotAnalyzeSpreadsheetRequestQueryParams,
    PostDraftPlotAnalyzeSpreadsheetRequestBodyData,
    PostDraftPlotAnalyzeSpreadsheetSuccessDto,
    PostDraftPlotAnalyzeSpreadsheetErrorDto
  >(POST_DRAFT_PLOT_ANALYZE_SPREADSHEET_PATH);
};

export const usePostDraftPlotFromSpreadsheet = () => {
  return useApiPostRequest<
    PostDraftPlotFromSpreadsheetRequestPathVariables,
    PostDraftPlotFromSpreadsheetRequestQueryParams,
    PostDraftPlotFromSpreadsheetRequestBodyData,
    PostDraftPlotFromSpreadsheetSuccessDto,
    PostDraftPlotFromSpreadsheetErrorDto
  >(POST_DRAFT_PLOT_FROM_SPREADSHEET_PATH);
};

export const usePatchDraftPlot = () => {
  return useApiPatchRequest<
    PatchDraftPlotRequestPathVariables,
    PatchDraftPlotRequestQueryParams,
    PatchDraftPlotRequestBodyData,
    PatchDraftPlotSuccessDto,
    PatchDraftPlotErrorDto
  >(PATCH_DRAFT_PLOT_PATH);
};

export const useBulkPatchDraftPlot = () => {
  return useApiPatchRequest<
    PatchDraftPlotBulkRequestPathVariables,
    PatchDraftPlotBulkRequestQueryParams,
    PatchDraftPlotBulkRequestBodyData,
    PatchDraftPlotBulkSuccessDto,
    PatchDraftPlotBulkErrorDto
  >(PATCH_DRAFT_PLOT_BULK_PATH);
};

export const useDeleteDraftPlot = () => {
  return useApiDeleteRequest<
    DeleteDraftPlotRequestPathVariables,
    DeleteDraftPlotRequestQueryParams,
    DeleteDraftPlotSuccessDto,
    DeleteDraftPlotErrorDto
  >(DELETE_DRAFT_PLOT_PATH);
};

export const useDeleteDraftPlotDiscard = () => {
  return useApiDeleteRequest<
    DeleteDraftPlotDiscardRequestPathVariables,
    DeleteDraftPlotDiscardRequestQueryParams,
    DeleteDraftPlotDiscardSuccessDto,
    DeleteDraftPlotDiscardErrorDto
  >(DELETE_DRAFT_PLOT_DISCARD_PATH);
};

export const useGetPlots = buildUseGetQuery<
  GetPlotRequestPathVariables,
  GetPlotRequestQueryParams,
  GetPlotSuccessDto,
  GetPlotErrorDto
>((params) => ['land_steward', 'plot', params], GET_PLOT_PATH);

export const useGetPlotById = buildUseGetQuery<
  GetPlotByIdRequestPathVariables,
  GetPlotByIdRequestQueryParams,
  GetPlotByIdSuccessDto,
  GetPlotByIdErrorDto
>((params) => ['land_steward', 'plot', params?.pathVariables.id, params], GET_PLOT_BY_ID_PATH);

export const usePostPlot = () => {
  return useApiPostRequest<
    PostPlotRequestPathVariables,
    PostPlotRequestQueryParams,
    PostPlotRequestBodyData,
    PostPlotSuccessDto,
    PostPlotErrorDto
  >(POST_PLOT_PATH);
};

export const usePatchPlot = (
  options?: Omit<
    UseMutationOptions<
      PatchPlotSuccessDto,
      PatchPlotErrorDto,
      RequestData<PatchPlotRequestPathVariables, PatchPlotRequestQueryParams, PatchPlotRequestBodyData>
    >,
    'mutationFn'
  >,
) => {
  return useApiPatchRequest<
    PatchPlotRequestPathVariables,
    PatchPlotRequestQueryParams,
    PatchPlotRequestBodyData,
    PatchPlotSuccessDto,
    PatchPlotErrorDto
  >(PATCH_PLOT_PATH, options);
};

export const useDeletePlot = () => {
  return useApiDeleteRequest<
    DeletePlotRequestPathVariables,
    DeletePlotRequestQueryParams,
    DeletePlotSuccessDto,
    DeletePlotErrorDto
  >(DELETE_PLOT_PATH);
};

export const useGetPlotQuestionnaire = buildUseGetQuery<
  GetPlotQuestionnaireRequestPathVariables,
  GetPlotQuestionnaireRequestQueryParams,
  GetPlotQuestionnaireSuccessDto,
  GetPlotQuestionnaireErrorDto
>(
  (params) => ['land_steward', 'plot', params?.pathVariables.id, 'get_questionnaire', params],
  GET_PLOT_QUESTIONNAIRE_PATH,
);

export const usePatchPlotQuestionnaire = (
  options?: Omit<
    UseMutationOptions<
      PatchPlotQuestionnaireSuccessDto,
      PatchPlotQuestionnaireErrorDto,
      RequestData<
        PatchPlotQuestionnaireRequestPathVariables,
        PatchPlotQuestionnaireRequestQueryParams,
        PatchPlotQuestionnaireRequestBodyData
      >
    >,
    'mutationFn'
  >,
) => {
  return useApiPatchRequest<
    PatchPlotQuestionnaireRequestPathVariables,
    PatchPlotQuestionnaireRequestQueryParams,
    PatchPlotQuestionnaireRequestBodyData,
    PatchPlotQuestionnaireSuccessDto,
    PatchPlotQuestionnaireErrorDto
  >(PATCH_PLOT_QUESTIONNAIRE_PATH, options);
};

export const usePostPlotValidateMultiPolygon = () => {
  return useApiPostRequest<
    PostPlotValidateMultiPolygonRequestPathVariables,
    PostPlotValidateMultiPolygonRequestQueryParams,
    PostPlotValidateMultiPolygonRequestBodyData,
    PostPlotValidateMultiPolygonSuccessDto,
    PostPlotValidateMultiPolygonErrorDto
  >(POST_PLOT_VALIDATE_MULTI_POLYGON_PATH);
};

export const useGetBuyerPlots = buildUseGetQuery<
  GetBuyerPlotsRequestPathVariables,
  GetBuyerPlotsRequestQueryParams,
  GetBuyerPlotsSuccessDto,
  GetBuyerPlotsErrorDto
>((params) => ['buyer', 'plot', params], GET_BUYER_PLOTS_PATH);

export const useGetBuyerPlotById = buildUseGetQuery<
  GetBuyerPlotByIdRequestPathVariables,
  GetBuyerPlotByIdRequestQueryParams,
  GetBuyerPlotByIdSuccessDto,
  GetBuyerPlotByIdErrorDto
>((params) => ['buyer', 'plot', params?.pathVariables.id, params], GET_BUYER_PLOT_BY_ID_PATH);

export const usePostPlotOverview = () => {
  return useApiPostRequest<
    PostPlotOverviewRequestPathVariables,
    PostPlotOverviewRequestQueryParams,
    PostPlotOverviewRequestBodyData,
    PostPlotOverviewSuccessDto,
    PostPlotOverviewErrorDto
  >(POST_PLOT_OVERVIEW_PATH);
};

export const usePatchPlotOverview = (
  options?: Omit<
    UseMutationOptions<
      PatchPlotOverviewSuccessDto,
      PatchPlotOverviewErrorDto,
      RequestData<
        PatchPlotOverviewRequestPathVariables,
        PatchPlotOverviewRequestQueryParams,
        PatchPlotOverviewRequestBodyData
      >
    >,
    'mutationFn'
  >,
) => {
  return useApiPatchRequest<
    PatchPlotOverviewRequestPathVariables,
    PatchPlotOverviewRequestQueryParams,
    PatchPlotOverviewRequestBodyData,
    PatchPlotOverviewSuccessDto,
    PatchPlotOverviewErrorDto
  >(PATCH_PLOT_OVERVIEW_PATH, options);
};

export const useDeletePlotOverview = () => {
  return useApiDeleteRequest<
    DeletePlotOverviewRequestPathVariables,
    DeletePlotOverviewRequestQueryParams,
    DeletePlotOverviewSuccessDto,
    DeletePlotOverviewErrorDto
  >(DELETE_PLOT_OVERVIEW_PATH);
};

export const usePostPlotOverviewMediaFile = () => {
  return useApiPostRequest<
    PostPlotOverviewMediaFileRequestPathVariables,
    PostPlotOverviewMediaFileRequestQueryParams,
    PostPlotOverviewMediaFileRequestBodyData,
    PostPlotOverviewMediaFileSuccessDto,
    PostPlotOverviewMediaFileErrorDto
  >(POST_PLOT_OVERVIEW_MEDIA_FILE_PATH);
};

export const usePatchPlotOverviewMediaFile = (
  options?: Omit<
    UseMutationOptions<
      PatchPlotOverviewMediaFileSuccessDto,
      PatchPlotOverviewMediaFileErrorDto,
      RequestData<
        PatchPlotOverviewMediaFileRequestPathVariables,
        PatchPlotOverviewMediaFileRequestQueryParams,
        PatchPlotOverviewMediaFileRequestBodyData
      >
    >,
    'mutationFn'
  >,
) => {
  return useApiPatchRequest<
    PatchPlotOverviewMediaFileRequestPathVariables,
    PatchPlotOverviewMediaFileRequestQueryParams,
    PatchPlotOverviewMediaFileRequestBodyData,
    PatchPlotOverviewMediaFileSuccessDto,
    PatchPlotOverviewMediaFileErrorDto
  >(PATCH_PLOT_OVERVIEW_MEDIA_FILE_PATH, options);
};

export const useDeletePlotOverviewMediaFile = () => {
  return useApiDeleteRequest<
    DeletePlotOverviewMediaFileRequestPathVariables,
    DeletePlotOverviewMediaFileRequestQueryParams,
    DeletePlotOverviewMediaFileSuccessDto,
    DeletePlotOverviewMediaFileErrorDto
  >(DELETE_PLOT_OVERVIEW_MEDIA_FILE_PATH);
};

export const useGetDraftPlotGroups = buildUseGetQuery<
  GetDraftPlotGroupRequestPathVariables,
  GetDraftPlotGroupRequestQueryParams,
  GetDraftPlotGroupSuccessDto,
  GetDraftPlotGroupErrorDto
>((params) => ['land_steward', 'draftplotgroup', params], GET_DRAFT_PLOT_GROUP_PATH);

export const usePostDraftPlotGroup = () => {
  return useApiPostRequest<
    PostDraftPlotGroupRequestPathVariables,
    PostDraftPlotGroupRequestQueryParams,
    PostDraftPlotGroupRequestBodyData,
    PostDraftPlotGroupSuccessDto,
    PostDraftPlotGroupErrorDto
  >(POST_DRAFT_PLOT_GROUP_PATH);
};

export const usePatchDraftPlotGroup = () => {
  return useApiPatchRequest<
    PatchDraftPlotGroupRequestPathVariables,
    PatchDraftPlotGroupRequestQueryParams,
    PatchDraftPlotGroupRequestBodyData,
    PatchDraftPlotGroupSuccessDto,
    PatchDraftPlotGroupErrorDto
  >(PATCH_DRAFT_PLOT_GROUP_PATH);
};

export const useDeleteDraftPlotGroup = () => {
  return useApiDeleteRequest<
    DeleteDraftPlotGroupRequestPathVariables,
    DeleteDraftPlotGroupRequestQueryParams,
    DeleteDraftPlotGroupSuccessDto,
    DeleteDraftPlotGroupErrorDto
  >(DELETE_DRAFT_PLOT_GROUP_PATH);
};

export const useBulkAssignDraftPlots = () => {
  return useApiPatchRequest<
    PatchDraftPlotBulkAssignRequestPathVariables,
    PatchDraftPlotBulkAssignRequestQueryParams,
    PatchDraftPlotBulkAssignRequestBodyData,
    PatchDraftPlotBulkAssignSuccessDto,
    PatchDraftPlotBulkAssignErrorDto
  >(PATCH_DRAFT_PLOT_BULK_ASSIGN_PATH);
};

export const useDeleteDraftPlotBulkDelete = () => {
  return useApiDeleteRequest<
    DeleteDraftPlotBulkDeleteRequestPathVariables,
    DeleteDraftPlotBulkDeleteRequestQueryParams,
    DeleteDraftPlotBulkDeleteSuccessDto,
    DeleteDraftPlotBulkDeleteErrorDto
  >(DELETE_DRAFT_PLOT_BULK_DELETE_PATH);
};
